import { styled } from "@mui/material";
import type { ComponentPropsWithRef } from "react";

interface ContainerProps extends ComponentPropsWithRef<"div"> {
  fullWidth?: boolean;
}

export const Container = styled("div", {
  shouldForwardProp: (propName: keyof ContainerProps) =>
    propName !== "fullWidth",
})<ContainerProps>(({ fullWidth }) => ({
  display: fullWidth ? "block" : "inline-block",
}));
